import { SocketLobbySend } from '../../socket/SocketLobbySend.ts';
import { UILobbyTableRowController } from './UILobbyTableRowController.ts';
import { notificationController, socket } from '../../EntryShared.ts';
import { LobbyImage } from '@colonist/types';
import { GameSorter } from '../../../../../shared/GameSorter.ts';
import { createDivIn } from '../../ui_utils/DomUtils.ts';
import { UIAjaxWrapper } from '../../network/UIAjaxWrapper.ts';
import { UIAPIEndpoints } from '../../network/UIAPIEndpoints.ts';
import { ClientUserState } from '../../ClientUserState.ts';
export class UILobbyRoomListController {
    activate() {
        this.clear();
        if (socket.controller.isSocketOpen()) {
            SocketLobbySend.watchRoomList();
        } else {
            void this.fetchRooms();
            this.fetchRoomsInterval = setInterval(()=>void this.fetchRooms(), 2 * 1000);
        }
        this.clearRoomsInterval = setInterval(()=>this.clearRooms(), 2 * 1000) // interval needs to match room_update_progress_animation
        ;
    }
    destroy() {
        clearInterval(this.clearRoomsInterval);
        clearInterval(this.fetchRoomsInterval);
        SocketLobbySend.stopWatchingRoomList();
        this.clear();
        this.unregisterSessionEstablishedObserver();
    }
    update(data) {
        var _ClientUserState_userState;
        if (data.full) this.clear();
        const usersKarma = (_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.karma;
        const rooms = this.getInitialRoomsSorted(data.rooms, usersKarma);
        for (const room of rooms){
            if (!this.rooms.has(room.id)) {
                this.rooms.set(room.id, {
                    room: room,
                    lobbyRow: new UILobbyTableRowController(this.tableBody, convertRoomUpdateDataToLobbyRowData(room), (roomId)=>this.clickedRoom(roomId))
                });
            }
            const existingRoom = this.rooms.get(room.id);
            existingRoom.room = room;
            existingRoom.lobbyRow.update(convertRoomUpdateDataToLobbyRowData(room));
            const isRoomUnavailable = !existingRoom.room.visible || this.unavailableRooms.has(room.id);
            existingRoom.lobbyRow.setRoomAvailable(usersKarma, isRoomUnavailable);
        }
    }
    setRoomUnavailable(roomId) {
        const existingRoom = this.rooms.get(roomId);
        existingRoom === null || existingRoom === void 0 ? void 0 : existingRoom.lobbyRow.setRoomAvailable(undefined, true);
    }
    async fetchRooms() {
        const result = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiGetRoomList(), undefined);
        if (result == undefined) return;
        const { rooms } = result.json;
        this.update({
            full: false,
            rooms: rooms
        });
        for (const [existingRoomId, existingRoom] of this.rooms){
            const roomStillAvailable = rooms.some((newRoom)=>newRoom.id === existingRoomId);
            if (roomStillAvailable) continue;
            existingRoom.room = {
                ...existingRoom.room,
                visible: false
            };
        }
    }
    clearRooms() {
        if (this.removeRooms) {
            const removedRooms = Array.from(this.rooms.values()).filter((room)=>!room.room.visible);
            for (const room of removedRooms){
                room.lobbyRow.remove();
                this.rooms.delete(room.room.id);
            }
        }
        for (const progressElements of this.header.getElementsByClassName('room_update_progress')){
            this.header.removeChild(progressElements);
        }
        this.removeRooms = this.rooms.size > 0;
        createDivIn(this.header, `room_update_progress ${this.removeRooms ? 'room_update_progress_animation' : ''}`);
    }
    getInitialRoomsSorted(rooms, usersKarma) {
        if (this.rooms.size) {
            return rooms;
        }
        const roomSorter = new GameSorter();
        return roomSorter.sort(rooms.map(convertRoomUpdateDataToLobbyRowData), usersKarma);
    }
    clickedRoom(roomId) {
        var _this_rooms_get;
        if (((_this_rooms_get = this.rooms.get(roomId)) === null || _this_rooms_get === void 0 ? void 0 : _this_rooms_get.room.visible) != true) {
            notificationController.showNotification(LobbyImage.Lightning, {
                key: 'strings:homePage.lobbyPage.popups.roomNoLongerExists'
            });
            return;
        }
        this.onRoomClick(roomId);
    }
    clear() {
        this.rooms.clear();
        this.tableBody.replaceChildren();
    }
    constructor(tableBody, header, onRoomClick, unavailableRooms){
        this.rooms = new Map();
        this.removeRooms = false;
        this.tableBody = tableBody;
        this.header = header;
        this.onRoomClick = onRoomClick;
        this.unavailableRooms = unavailableRooms;
        this.unregisterSessionEstablishedObserver = socket.controller.registerSessionEstablishedObserver(()=>{
            const isListDisplayed = this.clearRoomsInterval !== undefined;
            if (isListDisplayed) {
                this.clear();
                SocketLobbySend.watchRoomList();
            }
        });
    }
}
function convertRoomUpdateDataToLobbyRowData(room) {
    return {
        ...room,
        gameMapSetting: room.map,
        gameModeSetting: room.mode
    };
}
